import { useDispatch, useSelector } from 'react-redux';
import { Badge, List, ListItem, ListItemIcon, ListItemText, Toolbar, useTheme } from '@mui/material';
import { AccountBox, ContactPhone, Description, People, Quiz, Receipt, Sell, Send, Settings, Share } from '@mui/icons-material';
import config from '../../config';
import { setVisibility } from '../../store/actions/referralcodes-actions';

const AccountMenu = (props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { history } = props;

  const user = useSelector((state) => state.auth.user);
  const isEmailConfirmed = useSelector((state) => state.auth.isEmailConfirmed);
  const isPhoneNumberConfirmed = useSelector((state) => state.auth.isPhoneNumberConfirmed);
  const userProfilePending = useSelector((state) => state.auth.userProfilePending);
  const kycPending = useSelector((state) => state.auth.kycPending);
  const kycQnAPending = useSelector((state) => state.auth.kycQnAPending);
  const isPinRequired = useSelector((state) => state.app.isPinRequired);
  const isAccountPinSet = useSelector((state) => state.auth.isAccountPinSet);
  const nationalIdInvalid = useSelector((state) => state.auth.nationalIdInvalid);
  const transactionsInCompliancePending = useSelector((state) => state.app.transactionsInCompliancePending);
  const isBankIdRegistered = useSelector((state) => state.auth.user?.account?.isBankIdRegistered);
  const isAccountContactsVerificationRequired = useSelector((state) => state.app.isAccountContactsVerificationRequired);

  const processors = config.REACT_APP_AUTH_PROCESSOR
    ? config.REACT_APP_AUTH_PROCESSOR.split(',').map((ps) => {
        const stringSplit = ps.split('|');
        return {
          processor: stringSplit[0],
          countries: stringSplit[1].split('/'),
        };
      })
    : [];
  const processor = processors.find((p) => p.countries.includes(user.country?.toUpperCase()))?.processor;

  const handleRoute = (route) => {
    history.push('/account/' + route);
  };

  const handleOpenReferralCode = () => {
    dispatch(setVisibility(true));
  };

  return (
    <div>
      <Toolbar sx={{ margin: '16px' }} />
      {/* <Divider /> */}
      <List>
        <ListItem button key="SendNow" onClick={() => history.push('/remit')}>
          <ListItemIcon>
            <Send sx={{ color: theme.palette.specifics.accountNavBarItemIconColor }} />
          </ListItemIcon>
          <ListItemText primary="Send Now" />
        </ListItem>
        <ListItem button key="Recipients" onClick={handleRoute.bind(this, 'recipients')}>
          <ListItemIcon>
            <People sx={{ color: theme.palette.specifics.accountNavBarItemIconColor }} />
          </ListItemIcon>
          <ListItemText primary="Recipients" />
        </ListItem>
        <ListItem button key="Transactions" onClick={handleRoute.bind(this, 'transactions')}>
          <ListItemIcon>
            <Badge color="danger" variant="dot" invisible={!transactionsInCompliancePending}>
              <Receipt
                sx={{
                  color: theme.palette.specifics.accountNavBarItemIconColor,
                }}
              />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Transactions" />
        </ListItem>
        <ListItem button key="Profile" onClick={handleRoute.bind(this, 'profile')}>
          <ListItemIcon>
            <Badge color="danger" variant="dot" invisible={!userProfilePending}>
              <AccountBox
                sx={{
                  color: theme.palette.specifics.accountNavBarItemIconColor,
                }}
              />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Profile" />
        </ListItem>
        {isAccountContactsVerificationRequired && (!isEmailConfirmed || !isPhoneNumberConfirmed) && (
          <ListItem button key="Contact Details" onClick={handleRoute.bind(this, 'contacts')}>
            <ListItemIcon>
              <Badge color="danger" variant="dot">
                <ContactPhone
                  sx={{
                    color: theme.palette.specifics.accountNavBarItemIconColor,
                  }}
                />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Contact Details" />
          </ListItem>
        )}
        <ListItem button key="Documents" onClick={handleRoute.bind(this, 'documents')}>
          <ListItemIcon>
            <Badge color="danger" variant="dot" invisible={!kycPending && !nationalIdInvalid}>
              <Description
                sx={{
                  color: theme.palette.specifics.accountNavBarItemIconColor,
                }}
              />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Documents" />
        </ListItem>

        {config.REACT_APP_KYC_QNA_ENABLED === 'true' && kycQnAPending && (
          <ListItem button key="Questionnaire" onClick={handleRoute.bind(this, 'questionnaire')}>
            <ListItemIcon>
              <Badge color="danger" variant="dot" invisible={!kycQnAPending}>
                <Quiz
                  sx={{
                    color: theme.palette.specifics.accountNavBarItemIconColor,
                  }}
                />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Questionnaire" />
          </ListItem>
        )}
        {((!!processor &&
          !isBankIdRegistered &&
          !user.account?.bankIdProviders?.map((bp) => bp.toLowerCase())?.includes(processor?.toLowerCase()) &&
          config.REACT_APP_AUTH_PROCESSOR_COUNTRIES &&
          config.REACT_APP_AUTH_PROCESSOR_COUNTRIES.split(',').includes(user.country?.toUpperCase())) ||
          isPinRequired) && (
          <ListItem button key="Settings" onClick={handleRoute.bind(this, 'settings')}>
            <ListItemIcon>
              <Badge color="danger" variant="dot" invisible={!isPinRequired || (isPinRequired && isAccountPinSet)}>
                <Settings
                  sx={{
                    color: theme.palette.specifics.accountNavBarItemIconColor,
                  }}
                />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItem>
        )}
        {config.REACT_APP_DISCOUNT_CODE_ENABLED === 'true' && (
          <ListItem button key="Discount Codes" onClick={handleRoute.bind(this, 'promocodes')}>
            <ListItemIcon>
              <Sell>
                <Description
                  sx={{
                    color: theme.palette.specifics.accountNavBarItemIconColor,
                  }}
                />
              </Sell>
            </ListItemIcon>
            <ListItemText primary="Discount Codes" />
          </ListItem>
        )}

        {config.REACT_APP_REFERRAL_CODE_ENABLED === 'true' && (
          <ListItem button key="Referral Code" onClick={handleOpenReferralCode.bind(this)}>
            <ListItemIcon>
              <Share>
                <Description
                  sx={{
                    color: theme.palette.specifics.accountNavBarItemIconColor,
                  }}
                />
              </Share>
            </ListItemIcon>
            <ListItemText primary="Referral Code" />
          </ListItem>
        )}
      </List>
    </div>
  );
};

export default AccountMenu;
